import SanierungsService from "@/businesslogic/services/SanierungsService";
import ExtraSelbstbeteiligungService from "@/businesslogic/services/ExtraSelbstbeteiligungService";
import dateUtils from "@/businesslogic/utils/dateUtils";
import dataUtils from "@/businesslogic/utils/dataUtils";
import { useFormStore } from "@/businesslogic/stores/formStore";

export default function sanierungUtils() {
  const piniaStore = useFormStore();
  const { getNow } = dateUtils();
  const { gt, sub } = dataUtils();

  function pruefeSanierung(versBeginn: string) {
    if (piniaStore.state.gebaeudedaten.sanierungsdaten.sanierungsdatenAbgefragt) {
      ExtraSelbstbeteiligungService.leitungswasserSelbstbeteiligungPruefen(piniaStore.state, versBeginn).then((res) => {
        piniaStore.state.tarifinformationen.extraSelbstbeteiligungLeitungswasser =
          res.data && !piniaStore.state.isMakler ? 750 : 0;
      });

      SanierungsService.kernsanierungPruefen(piniaStore.state, versBeginn)
        .then((res) => {
          piniaStore.state.tarifinformationen.kernsanierung = res.data;
        })
        .then(() => {
          ermittelKernsanierungsjahr();
        });
    }
  }

  function ermittelKernsanierungsjahr() {
    if (piniaStore.state.tarifinformationen.kernsanierung) {
      SanierungsService.kernsanierungsjahrErmitteln(piniaStore.state).then((res) => {
        piniaStore.state.gebaeudedaten.sanierungsdaten.kernsanierungsjahr = res.data;
      });
    } else {
      piniaStore.state.gebaeudedaten.sanierungsdaten.kernsanierungsjahr = null;
    }
  }

  function gebaeudeAelter30(versBeginn: Date | null) {
    if (!versBeginn) {
      versBeginn = getNow();
    }

    return gt(sub(versBeginn?.getFullYear(), piniaStore.state.gebaeudedaten.baujahr), 30) && istJahrVierstellig();
  }

  function gebaeudeAelter50(versBeginn: Date | null) {
    if (!versBeginn) {
      versBeginn = getNow();
    }

    return gt(sub(versBeginn?.getFullYear(), piniaStore.state.gebaeudedaten.baujahr), 50) && istJahrVierstellig();
  }

  function istJahrVierstellig(): boolean {
    return (
      piniaStore.state.gebaeudedaten.baujahr !== null && piniaStore.state.gebaeudedaten.baujahr.toString().length === 4
    );
  }

  return {
    pruefeSanierung,
    ermittelKernsanierungsjahr,
    gebaeudeAelter30,
    gebaeudeAelter50,
  };
}
